import React, { Component } from 'react';
import AppData from '../../Model/AppData';
class CountDownTimer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            countdown_time: -1,
            countdown_timeStr: "0:00",
        };
        this.countDownTimer = null
        this.buttonRef = React.createRef()
    }
    componentDidMount() {
        this.updateCountDownTimer()
    }
    componentWillReceiveProps() {
        this.updateCountDownTimer()
    }
    componentDidUpdate() {
        $('#btnCountdown').popover()
        if (!AppData.data) {
            return
        }
        if (this.buttonRef.current) {
            if (!this.countDownTimer) {
                this.countDownTimer = setInterval(this.updateCountDownTimer.bind(this), 1000)
            }
        }
        else {
            this.clearTimer()
        }
        if (!window.timerHintShown && this.buttonRef.current != null) {
            // On every page load, only auto show this popover once
            window.timerHintShown = true
            setTimeout(() => this.buttonRef.current && this.buttonRef.current.click(), 1500);
        }
    }
    clearTimer = () => {
        if (this.countDownTimer !== null) {
            clearInterval(this.countDownTimer)
            this.countDownTimer = null
        }
    }
    componentWillUnmount() {
        this.clearTimer()
    }


    // Update the time remaining to Confirm All Orders
    updateCountDownTimer() {
        if (!AppData.data) {
            return
        }
        let lastDraftOrder = null;
        let acceptedOrders = (AppData.data.state.orders || []).filter(order => order.order_status == 'accepted');
        if (acceptedOrders.length > 0) {
            // Has confirmed orders, no need show timer
            this.setState({
                countdown_time: -1
            }, this.clearTimer)
            return;
        }

        const draftOrders = (AppData.data.state.orders || []).filter(order => order.order_status == 'draft')
        const draftOrderTime = draftOrders.map(a => a.updated_at)

        // Assume simple string comparison is good enough to 
        // sort DateTime string of yyyy-mm-dd HH:mm:ss
        draftOrderTime.sort()

        const lastTime = draftOrderTime.pop()
        if (!lastTime) {
            // No draft orders
            this.setState({
                countdown_time: -1
            }, this.clearTimer)
            return
        }

        const bufferTime = table_session_timeout * 60
        const lastOrderDateTime = moment(lastTime)
        const deadlineTime = lastOrderDateTime.add(bufferTime, 'second')
        const now = moment()
        let diffSecond = deadlineTime.diff(now) / 1000
        const minuteAndSecond = moment.utc(diffSecond * 1000).format('mm:ss');
        if (diffSecond < 0) {
            $.ajax({
                url: '/cron/close_inactive_session',
            })
            diffSecond = diffSecond < 0 ? 0 : diffSecond
            this.setState({
                countdown_time: 0,
                countdown_timeStr: "0.00"
            })
        }
        else {
            this.setState({
                countdown_time: diffSecond,
                countdown_timeStr: minuteAndSecond
            })
        }
    }
    render() {
        const placement = "bottom"


        // <Popover/> has additional right margin added
        // from app_extra.css
        return (
            this.state.countdown_time > 0 && <button id="btnCountdown" ref={this.buttonRef} className="navbar-btn btn btn-sm btn-default pull-right"
                data-toggle="popover" data-content={lang.confirm_order_before_timeout}
                data-placement="bottom"
            >
                {this.state.countdown_timeStr}
            </button>
        )
    }
}

export default CountDownTimer;